import { JSX } from "react";

import IconButton from "@mui/material/IconButton";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export type InfoButtonProps = {
	onClick: () => void;
};

export default function InfoButton(
	props: Readonly<InfoButtonProps>
): JSX.Element {
	return (
		<IconButton aria-label="info" color="info" onClick={props.onClick}>
			<InfoOutlinedIcon />
		</IconButton>
	);
}
